import * as actionTypes from '../actions/actionTypes';

const initialState = {
    countries: [],
    customer: null,
    // last_open_buy_id: null,
    login_success: null,
    register_success: null,
    new_enum: null,
    new_photos: null,
    deleted_photo_id: null,
    address: null,
    update_address_success: null,
    get_customer_success: null,
    update_customer_success: null,
    reset_password_success: null,
    change_password_success: null,
    verify_account_success: null
};

const loginSuccess = (state, action) => {
    const newState = {
        ...state,
        login_success: action.login_success,
        error: action.error,
        address: action.address,
        customer: action.customer,
        loading: action.loading
    }
    return newState
};
const loginStart = (state, action) => {
    const newState = {
        ...state,
        loading: action.loading,
    }
    return newState
};
const resetLoginSuccess = (state, action) => {
    const newState = {
        ...state,
        login_success: action.login_success,
    }
    return newState
};

const registerSuccess = (state, action) => {
    const newState = {
        ...state,
        register_success: action.register_success,
        loading: action.loading,
        address: action.address,
        customer: action.customer,
        error: action.error
    }
    return newState
};
const registerStart = (state, action) => {
    const newState = {
        ...state,
        loading: action.loading,
    }
    return newState
};
const resetRegisterSuccess = (state, action) => {
    const newState = {
        ...state,
        register_success: action.register_success,
    }
    return newState
};

const getCountriesSuccess = (state, action) => {
    const newState = {
        ...state,
        countries: [...action.countries],
        error: action.error
    }
    return newState
};
const addEnumSuccess = (state, action) => {
    const newState = {
        ...state,
        new_enum: action.newEnum,
        loading: action.loading,
        error: action.error
    }
    return newState
};
const addEnumStart = (state, action) => {
    const newState = {
        ...state,
        loading: action.loading,
    }
    return newState
};
const resetNewEnum = (state, action) => {
    const newState = {
        ...state,
        new_enum: action.newEnum,
    }
    return newState
};

const resetPasswordSuccess = (state, action) => {
    const newState = {
        ...state,
        reset_password_success: action.reset_password_success,
        error: action.error
    }
    return newState
}; 
const resetResetPasswordSuccess = (state, action) => {
    const newState = {
        ...state,
        reset_password_success: action.reset_password_success,
    }
    return newState
}; 

const changePasswordStart = (state, action) => {
    const newState = {
        ...state,
        loading: action.loading
    }
    return newState
}; 
const changePasswordSuccess = (state, action) => {
    const newState = {
        ...state,
        change_password_success: action.change_password_success,
        error: action.error,
        loading: action.loading
    }
    return newState
}; 
const resetChangePasswordSuccess = (state, action) => {
    const newState = {
        ...state,
        change_password_success: action.change_password_success,
    }
    return newState
}; 

const getCustomerSuccess = (state, action) => {
    const newState = {
        ...state,
        customer: action.customer,
        error: action.error,
        get_customer_success: action.get_customer_success,
    }
    return newState
};
const getCustomerStart = (state, action) => {
    const newState = {
        ...state,
        loading: action.loading,
    }
    return newState
};
const resetGetCustomerSuccess = (state, action) => {
    const newState = {
        ...state,
        get_customer_success: null,
    }
    return newState
};

const verifyAccountSuccess = (state, action) => {
    const newState = {
        ...state,
        error: action.error,
        loading: action.loading,
        verify_account_success: action.verify_account_success,
    }
    return newState
};
const verifyAccountStart = (state, action) => {
    const newState = {
        ...state,
        loading: action.loading,
    }
    return newState
};
const resetVerifyAccountSuccess = (state, action) => {
    const newState = {
        ...state,
        verify_account_success: null,
    }
    return newState
};
const addItemPhotosStart = (state, action) => {
    const newState = {
        ...state,
        loading: action.loading,
    }
    return newState
};

const addItemPhotosSuccess = (state, action) => {
    const newState = {
        ...state,
        new_photos: action.newPhotos,
        loading: action.loading,
        error: action.error
    }
    return newState
};
const resetNewPhotos = (state, action) => {
    const newState = {
        ...state,
        new_photos: action.newPhotos,
    }
    return newState
};

const deletePhotoSuccess = (state, action) => {
    const newState = {
        ...state,
        deleted_photo_id: action.deletedPhotoId,
        error: action.error,
        loading: action.loading
    }
    return newState
};
const deletePhotoStart = (state, action) => {
    const newState = {
        ...state,
        loading: action.loading,
    }
    return newState
};

const addAddressSuccess = (state, action) => {
    const newState = {
        ...state,
        error: action.error
    }
    return newState
};

const updateAddressSuccess = (state, action) => {
    const newState = {
        ...state,
        update_address_success: action.update_address_success,
        error: action.error,
        // loading: action.loading
    }
    return newState
};
const updateAddressStart = (state, action) => {
    const newState = {
        ...state,
        // loading: action.loading
    }
    return newState
};
const resetUpdateAddressSuccess = (state, action) => {
    const newState = {
        ...state,
        update_address_success: action.update_address_success,
    }
    return newState
};

const resetDeletedPhotoId = (state, action) => {
    const newState = {
        ...state,
        deleted_photo_id: null,
    }
    return newState
};

const updateCustomerSuccess = (state, action) => {
    const newState = {
        ...state,
        update_customer_success: action.update_customer_success,
        customer: action.customer,
        error: action.error,
        // loading: action.loading
    }
    return newState
};
const resetUpdateCustomerSuccess = (state, action) => {
    const newState = {
        ...state,
        update_customer_success: action.update_customer_success,
    }
    return newState
};

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.LOGIN_SUCCESS: return loginSuccess(state, action);
        case actionTypes.LOGIN_START: return loginStart(state, action);
        case actionTypes.RESET_LOGIN_SUCCESS: return resetLoginSuccess(state, action);
        case actionTypes.REGISTER_SUCCESS: return registerSuccess(state, action);
        case actionTypes.REGISTER_START: return registerStart(state, action);
        case actionTypes.RESET_REGISTER_SUCCESS: return resetRegisterSuccess(state, action);
        case actionTypes.GET_COUNTRIES_SUCCESS: return getCountriesSuccess(state, action);
        case actionTypes.GET_CUSTOMER_SUCCESS: return getCustomerSuccess(state, action);
        case actionTypes.RESET_GET_CUSTOMER_SUCCESS: return resetGetCustomerSuccess(state, action);
        case actionTypes.GET_CUSTOMER_START: return getCustomerStart(state, action);
        case actionTypes.ADD_ENUM_START: return addEnumStart(state, action);
        case actionTypes.ADD_ENUM_SUCCESS: return addEnumSuccess(state, action);
        case actionTypes.RESET_NEW_ENUM: return resetNewEnum(state, action);
        case actionTypes.RESET_NEW_PHOTOS: return resetNewPhotos(state, action);
        case actionTypes.ADD_ITEM_PHOTOS_SUCCESS: return addItemPhotosSuccess(state, action);
        case actionTypes.ADD_ITEM_PHOTOS_START: return addItemPhotosStart(state, action);
        case actionTypes.DELETE_PHOTO_SUCCESS: return deletePhotoSuccess(state, action);
        case actionTypes.DELETE_PHOTO_START: return deletePhotoStart(state, action);
        case actionTypes.RESET_DELETED_PHOTO_ID: return resetDeletedPhotoId(state, action);
        case actionTypes.ADD_ADDRESS_SUCCESS: return addAddressSuccess(state, action);
        case actionTypes.UPDATE_ADDRESS_SUCCESS: return updateAddressSuccess(state, action);
        case actionTypes.UPDATE_ADDRESS_START: return updateAddressStart(state, action);
        case actionTypes.RESET_UPDATE_ADDRESS_SUCCESS: return resetUpdateAddressSuccess(state, action);
        case actionTypes.UPDATE_CUSTOMER_SUCCESS: return updateCustomerSuccess(state, action);
        case actionTypes.RESET_UPDATE_CUSTOMER_SUCCESS: return resetUpdateCustomerSuccess(state, action);
        case actionTypes.RESET_PASSWORD_SUCCESS: return resetPasswordSuccess(state, action);
        case actionTypes.RESET_RESET_PASSWORD_SUCCESS: return resetResetPasswordSuccess(state, action);
        case actionTypes.CHANGE_PASSWORD_START: return changePasswordStart(state, action);
        case actionTypes.CHANGE_PASSWORD_SUCCESS: return changePasswordSuccess(state, action);
        case actionTypes.RESET_CHANGE_PASSWORD_SUCCESS: return resetChangePasswordSuccess(state, action);
        case actionTypes.VERIFY_ACCOUNT_SUCCESS: return verifyAccountSuccess(state, action);
        case actionTypes.VERIFY_ACCOUNT_START: return verifyAccountStart(state, action);
        case actionTypes.RESET_VERIFY_ACCOUNT_SUCCESS: return resetVerifyAccountSuccess(state, action);
        
        default: return state;
    }
};

export default reducer;